<style scoped>
    @import url("../../styles/dashMain/painelLoginTipoA.scss");
</style>

<template>
    <div class="box_main_col_login">

        <!-- TITULO MAIN -->
        <div class="box_tit_main_login mb-4" v-if="!flag_loading_loginAgro">
            
            <v-icon size="36" class="mb-2">mdi-lock</v-icon>
            <div class="tit mb-1" >Área do utilizador</div>
            <div class="sub_tit">Inicie sessão para gerir<br> serviços e encomendas.</div>
        </div>

        <!-- BODY LOGIN -->
        <div class="box_painelLoginTipoA">

            <div class="session_form mb-2 mt-2" v-if="flag_loading_loginAgro">

                <span class="mb-2" :style="{'display':'flex','align-self':'center','font-size':'0.7rem'}">Buscando suas informações</span>

                <v-progress-circular
                :size="70"
                :width="7"
                color="green"
                indeterminate
                :style="{'display':'flex','align-self':'center'}"
                ></v-progress-circular>

            </div>

            <v-form v-if="!flag_loading_loginAgro" class="session_form mt-4"
            ref="form"
            v-model="valid"
            lazy-validation
            >
                <v-text-field
                color="orange"
                v-model="nameClient"
                :rules="nameRules"
                label="Nome de usuário"
                required
                ></v-text-field>

                <v-text-field
                type="password"
                color="orange"
                v-model="passClient"
                label="Palavra chave"
                required
                ></v-text-field>
            </v-form>

            <div v-if="!flag_loading_loginAgro" class="btn_login">
                <v-btn
                small
                block
                :disabled="!valid"
                color="success"
                class="mr-4 mt-1"
                @click="chamarClientPage"
                >
                    entrar
                </v-btn>
            </div>

            <span v-if="!flag_loading_loginAgro"
            @mouseover="hoverCadastro = 'rgb(247,215,46)'"
            @mouseleave="hoverCadastro = 'rgb(31,122,177)'"
            class="cadastroNameClient mb-2" 
            @click="chamarCadastro()"
            :style="{'color':hoverCadastro}"
            >
                Registar</span>

            <span v-if="flagErrorLogin && !flag_loading_loginAgro"
            :style="{'margin-top':'10px','color':'red','font-size':'0.8rem'}">
                {{ msgErrorLogin }}
            </span>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            nameClient:'',
            passClient:'',
            hoverCadastro:'rgb(31,122,177)',
            flagErrorLogin:false,
            msgErrorLogin:'Usúario ou senha incorretos',

            valid: false, // btn 'entrar' inicia desabilitado.
            nameRules: [
                v => !!v || 'Preenchimento obrigatório',
            ],

            flag_loading_loginAgro:false,
        }
    },

    methods: {
        chamarClientPage() {

            this.flag_loading_loginAgro = true // iniciar loading...

            if (this.nameClient.length >= 3 && this.passClient.length >= 5) {

                var self = this

                if (this.$refs.form.validate()) {

                    var objUser = {}
                    var update_creden = {}
                    let tox = ''

                    // tmp login 10/09/2024
                    /*if (self.nameClient == 'cmf' && self.passClient == 'agrotech10') {

                        // teste de simulação: objeto usuário
                        objUser = {
                            'nome':self.nameClient,
                            'email':'geral@upinc.pt',
                            'liServs':[
                                {
                                    'serv':'Projecto ECO-NPK',
                                    'img':'url(' + require('../../assets/1qe1.jpeg') + ')',
                                    'content':'',
                                    'rota':'/smartfarm'
                                },
                            ],
                        }
                        self.$emit('openPainel',objUser) // emitir evento do neto ao pai.

                        // -- STORAGE
                        update_creden = {'flagLogadoDash':true}
                        localStorage.setItem('creden', JSON.stringify(update_creden))
                        localStorage.setItem('contentUser', JSON.stringify(objUser))

                        // -- habilitar entrada atual.
                        this.$store.state.contentUser = objUser
                        this.$store.state.flagLogadoDash = true
                        return
                    }*/

                    // tmp login 04/09/2024
                    /*if (self.nameClient == 'upinc' && self.passClient == '-uadm0') {

                        // teste de simulação: objeto usuário
                        objUser = {
                            'nome':self.nameClient,
                            'email':'geral@upinc.pt',
                            'liServs':[
                                {
                                    'serv':'Gateway LoRaWAN',
                                    'img':'url(' + require('../../assets/gopr1.jpg') + ')',
                                    'content':'',
                                    'rota':'/lora'
                                },
                                {
                                    'serv':'Contador Água',
                                    'img':'url(' + require('../../assets/countAguat0.png') + ')',
                                    'content':'',
                                    'rota':'/ca'
                                },
                                {
                                    'serv':'Controle remoto IoT',
                                    'img':'url(' + require('../../assets/controlt0.png') + ')',
                                    'content':'',
                                    'rota':'/exib'
                                },
                                {
                                    'serv':'Projecto ECO-NPK',
                                    'img':'url(' + require('../../assets/1qe1.jpeg') + ')',
                                    'content':'',
                                    'rota':'/smartfarm'
                                },
                                {
                                    'serv':'Smart Control',
                                    'img':'url(' + require('../../assets/logos/logo-smart-control-v1.png') + ')',
                                    'content':'',
                                    'rota':'/smartcontrol'
                                },
                                {
                                    'serv':'Projeto Montanha Viva',
                                    'img':'url(' + require('../../assets/logos/mvlogo.png') + ')',
                                    'content':'',
                                    'rota':'/mv'
                                },
                                {
                                    'serv':'Aquaponia',
                                    'img':'url(' + require('../../assets/aq1.png') + ')',
                                    'content':'',
                                    'rota':'/aquaponia'
                                },
                            ],
                        }

                        self.$emit('openPainel',objUser) // emitir evento do neto ao pai.
                        //self.flag_loading_loginAgro = false // desabilitar loading
                        //console.log('fim login ok')

                        update_creden = {'flagLogadoDash':true}
                        localStorage.setItem('creden', JSON.stringify(update_creden))
                        localStorage.setItem('contentUser', JSON.stringify(objUser))

                        // -- habilitar entrada atual.
                        this.$store.state.contentUser = objUser
                        this.$store.state.flagLogadoDash = true
                        return

                    } /*else {

                        self.flag_loading_loginAgro = false // desabilitar loading
                        self.flagErrorLogin = true
                        return
                    }*/

                    var payload = {'email':self.nameClient, 'senha':self.passClient }
                    
                    axios.post(self.$store.state.pathAxiosLoginNewSys, payload).then(function (res) {

                        //console.log(res.data.result)
                        //console.log(res.data.result.mensagem)
                        //console.log(res.data.result.token)
                        //console.log(res.data.result.usuario.liServs)
                        //console.log(res.data.result.usuario.nome)

                        if (res.data.result.mensagem == 'Credenciais validadas') {

                            objUser = {
                                'nome':res.data.result.usuario.nome,
                                'email':res.data.result.usuario.email,
                                'liServs':res.data.result.usuario.liServs
                            }
                            self.$emit('openPainel',objUser) // emitir evento do neto ao pai.

                            // -- STORAGE
                            tox = res.data.result.token
                            update_creden = {'flagLogadoDash':true}
                            localStorage.setItem('tokenx', JSON.stringify(tox))
                            localStorage.setItem('creden', JSON.stringify(update_creden))
                            localStorage.setItem('contentUser', JSON.stringify(objUser))

                            // -- habilitar entrada atual.
                            self.$store.state.tox = tox
                            self.$store.state.contentUser = objUser
                            self.$store.state.flagLogadoDash = true
                            return

                        } else {

                            self.flag_loading_loginAgro = false // desabilitar loading
                            self.flagErrorLogin = true
                            return
                        }
                    })

                } else {

                    self.flag_loading_loginAgro = false // desabilitar loading
                    self.flagErrorLogin = true
                    return
                }

                /*var el = {
                    'status': 'entrada', // 'entrada' 'ativo' 'saída' 'encerrado'
                    'cond':'pendente', // pendente ou verificado.
                    'fornecedor': this.nomeFornecedor,
                    'entrada': date.day, //'12/11/2022',
                    'hora': date.hr, //'12:16', // fuso-horário do servidor?
                    'produtos': li_final
                }
                this.$store.commit('inputLOTE', el)
                //this.flagErroPreench = false // não necessário pois volta a main page. ~reset~
                this.$store.state.flagProgressLOTE = true
                this.$router.push('/') // reset
                */

                self.flagErrorLogin = false // reset

            } else {
                
                this.flag_loading_loginAgro = false // desabilitar loading
                this.flagErrorLogin = true
                return
            }
        },
        chamarCadastro() {
            this.$store.state.flagCadastroUserAgro = true
        },
    },

    created() {
        //this.$store.commit('srcIPloja') // without param. Initial main GET Req.
    }
}
</script>